var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2H6.13239C5.42986 2 4.77885 2.3686 4.4174 2.97101L2.45001 6.25H11.25V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.25V2H17.8676C18.5701 2 19.2212 2.3686 19.5826 2.97101L21.55 6.25H12.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.75V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V7.75H2ZM16.0303 12.5303L11.0303 17.5303C10.8897 17.671 10.6989 17.75 10.5 17.75C10.3011 17.75 10.1103 17.671 9.96967 17.5303L7.96967 15.5303C7.67678 15.2374 7.67678 14.7626 7.96967 14.4697C8.26256 14.1768 8.73744 14.1768 9.03033 14.4697L10.5 15.9393L14.9697 11.4697C15.2626 11.1768 15.7374 11.1768 16.0303 11.4697C16.3232 11.7626 16.3232 12.2374 16.0303 12.5303Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox10);
export default __webpack_public_path__ + "static/media/box-10.568f5f0e230a8a01b6a88706f6caa5a6.svg";
export { ForwardRef as ReactComponent };